<script>
import {getCurrentInstance, onMounted, onBeforeUnmount, ref, watch} from 'vue';
import commonFn from '@/commons/commonFunction';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';
import _ from 'lodash';
import taskManagementApi from '@/apis/system/taskManagementApi';
import TaskLogApi from '@/apis/other/taskLogApi';
import popupUtil from '@/commons/popupUtil';
export default {
  components: {},
  props: {
    title: String,
    totalItem: {
      type: Number,
      default: 1,
    },
    width: {
      type: Number,
      default: 400,
    },
    message: [String, Array],
    type: {
      type: Number,
      default: 0,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    dataRow: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      default: null,
    },
  },

  setup(props) {
    const {proxy} = getCurrentInstance();

    const closeDialog = () => proxy.$close(proxy, null);

    const end = ref(0);

    let intervalId = ref();
    let intervalTask = ref();
    let taskId = ref();
    let numberVoucher = ref(0);
    let postType = ref(false);

    onMounted(() => {
      commonFn.focusFirstControl(proxy.$refs['msg']);
      EventBusGlobal.$on(GlobalEventName.postMultiCompleted, finishProgress);
      let isFirst = true;
      let intervalTime = 5000;

      taskId = proxy.data?.taskId;
      numberVoucher = proxy.data?.numberVoucher;
      postType = proxy.data?.isPost;

      intervalId.value = setInterval(async () => {
        if (isFirst) {
          end.value = 0;
          isFirst = false;
        }

        if (end.value < 99) {
          end.value++;
        }
      }, 100);

      // Tạo interval để check xem khi nào task thực hiện xong để tránh trường hợp web socket chết
      intervalTask.value = setInterval(async () => {
        const result = await taskManagementApi.getTaskManagement(taskId);
        if (result.status == 3) {
          finishProgress();
          clearInterval(intervalTask.value);
        }
      }, intervalTime);
    });

    /**
     * Thực hiện xử lý khi chạy hoàn thành 100$
     * HQMINH 14.11.2023
     */
    const finishProgress = async () => {
      setTimeout(() => {
        end.value = 100;
        closeDialog();
        showPopUpData();
      }, 500);
    };

    /**
     * Thực hiện mở PupUp thông báo khi thực hiện tham số
     * HQMINH 14.11.2023
     */
    const showPopUpData = async () => {
      const me = proxy;

      var result = await TaskLogApi.CheckResultPostMulti(taskId);
      if (result) {
        // show form danh sách lỗi ghi sổ, bỏ ghi
        popupUtil.show('PostMultiResult', {
          mode: me.$ms.constant.FormState.Add,
          taskId: taskId,
          postType: postType,
          options: {},
        });
      } else {
        if (postType) {
          // ghi sổ thành công
          me.$toast.success(me.$t('i18nBaseForm.Message.PostedSuccess'));
        } else {
          // Bỏ Ghi sổ thành công
          me.$toast.success(me.$t('i18nBaseForm.Message.UnPostedSuccess'));
        }
      }

      EventBusGlobal.$emit(GlobalEventName.gridReload);
    };

    function escPress(e, close) {
      e.preventDefault();
      close(this, null);
    }

    onBeforeUnmount(() => {
      EventBusGlobal.$off(GlobalEventName.postMultiCompleted, finishProgress);
      clearInterval(intervalId.value); // xóa interval sau khi đóng
      clearInterval(intervalTask.value);
    });

    return {
      escPress,
      end,
    };
  },
};
</script>

<template>
  <div class="msg-custom">
    <div class="msg-box" @keydown.esc="escPress($event, $close)">
      <div ref="msg" class="msg-center" :style="{width: width + 'px'}">
        <div class="msg-title">
          {{ title }}
        </div>
        <div class="msg-persent">{{ end }}%</div>
        <div class="progress-container">
          <div class="progress">
            <div class="progress-bar" :style="{width: end + '%'}"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/scss/components/MsMessageBox.scss';
.msg-custom {
  .msg-box {
    .msg-center {
      margin-left: 165px;
      right: 0px;
      bottom: 0px;
      height: 115px;
      transform: translate(-100%, -100%);
      background-color: white;
      box-shadow: 0 3px 20px rgba(0, 0, 0, 0.08);
      border-radius: $border-radius;
    }

    .msg-close {
      top: 20px;
      right: 20px;
      transform: scale(0.8);
    }

    .msg-persent {
      position: absolute;
      top: 48px;
      right: 20px;
      transform: scale(0.8);
      font-size: 18px;
    }

    a {
      color: $blue-text;
    }
  }

  .progress-container {
    margin-top: 30px;
    width: 100%;
  }

  .progress {
    background-color: #f7f7f7;
    border-radius: 6px;
    margin: 10px 20px 0px 20px;
  }

  .progress-bar {
    height: 18px;
    background-color: $primary;
    border-radius: 4px;
    transition: 0s linear;
    transition-property: width;
  }
}
</style>
